import { tns } from "tiny-slider/src/tiny-slider";

// this carousel can't change axis on responsive settings,
// so we have to destroy it when breakpoint is passed and reinit

$(function(){

    if ( $('.McAdvantagesWrapper').length )
    {
        let advantagesCarousel = null;

        function getCarouselSettings(){
            // default desktop options
            let options = {
                container: document.querySelector('.McAdvantagesCarousel'),
                items: 5,
                axis: "vertical",
                mouseDrag: true,
                gutter: 25,
                center: false,
                controls: false,
                nav: false,
                navPosition: 'bottom',
                autoplay: true,
                autoplayHoverPause: false, // is custom to the whole row
                autoplayResetOnVisibility: true,
                autoplayButton: false,
                autoplayButtonOutput: false,
                autoplayTimeout: 5000,
                loop: true,
                freezable: false,
                onInit: function(e){
                    // init custom pagination
                    setPaginationIndex(e.displayIndex);
                }
            };
    
            // mobile adjusted options
            if ( $(window).width() < 992 )
            {
                options.items = 1;
                options.axis = "horizontal";
                options.edgePadding = 15;
            }

            return options;
        }

        function initCarousel(){
            // destroy carousel if previously initted
            if (advantagesCarousel) {
                destroyCarousel();
            }

            // init nav bullets
            $('.McAdvantagesCarousel .McAdvantagesCarouselItem').each(function(index){
                $(this).attr('data-index', index);
                $('.McAdvantagesCarouselNav').append(`<button type="button" data-index="${index}" class="McAdvantagesCarouselNavItem"></button>`);
            });

            // init new carousel
            advantagesCarousel = tns(getCarouselSettings());

            // trigger pagination change when slider is changed
            advantagesCarousel.events.on('indexChanged', function(info, eventName){
                setPaginationIndex(info.displayIndex);
            });

            // change current slide when pagination is clicked
            $('.McAdvantagesCarouselNav .McAdvantagesCarouselNavItem').on('click', function(e){
                e.preventDefault();
                let index = $(this).data('index');
                advantagesCarousel.goTo(index);
            });

            // change current slide when other slide is cliked, 
            // real index is shifted by 2 on desktop,
            // therefore we have to go to index + 2x previous
            if ( $(window).width() >= 992 ){
                $('.McAdvantagesCarousel').on('click', '.tns-item', function(e){
                    e.preventDefault();
    
                    // click on self
                    if ( $(this).is( $('.tns-slide-active')[2] ) ) {
                        return;
                    }

                    // index of active clicked item
                    let activeIndex = $('.McAdvantagesCarousel .tns-slide-active').index(this);

                    // direction of rolling
                    let direction = 'prev';
                    if ( activeIndex > 2 ){
                        direction = 'next';
                    }

                    // if difference is 2 slides, slide 2, else slide one
                    if ( activeIndex == 0 || activeIndex == 4 ){
                        advantagesCarousel.goTo(direction);
                        advantagesCarousel.goTo(direction);
                    }
                    else
                    {
                        advantagesCarousel.goTo(direction);
                    }
                });
            }
        }

        function destroyCarousel(){
            // destroy carousel and remove its settings
            advantagesCarousel.destroy();
            advantagesCarousel = null;

            // destroy nav bullets
            $('.McAdvantagesCarouselNav').html('');
        }

        // init carousel
        initCarousel();

        // handle breakpoint change, set up watcher for specific breakpoint
        let isMobile = false;
        let wasMobile = false;
        $(window).on('resize', function(){
            if ( $(window).width() < 992 ){
                isMobile = true;
            }
            else
            {
                isMobile = false;
            }

            if ( isMobile != wasMobile ){
                // breakpoint changed
                initCarousel();
                wasMobile = isMobile;
            }   
        });

        // pause autoplay on hover
        $('.McAdvantagesWrapper').hover(
            function(){
                if ( advantagesCarousel ){
                    advantagesCarousel.pause();
                }
            },
            function(){
                if ( advantagesCarousel ){
                    advantagesCarousel.play();
                }
            }
        );

        function setPaginationIndex(index){
            // change active bullet
            $('.McAdvantagesCarouselNav .McAdvantagesCarouselNavItem').removeClass('McAdvantagesCarouselNavItemActive');
            let $activeItem = $($('.McAdvantagesCarouselNav .McAdvantagesCarouselNavItem')[index - 1]);
            $activeItem.addClass('McAdvantagesCarouselNavItemActive');

            // get image url
            let imgUrl = '';
            
            // timeout for slideItems array to get synced to HTML
            setTimeout(() => {
                // get the middle one on desktop or mobile (indexes and active items are fcked up on this carousel)
                if ( advantagesCarousel.getInfo().items === 5 ) {
                    imgUrl = $($(advantagesCarousel.getInfo().slideItems).filter('.tns-slide-active')[2]).data('img-url');
                }
                else
                {
                    imgUrl = $($(advantagesCarousel.getInfo().slideItems).filter('.tns-slide-active')[1]).data('img-url');
                }

                // call image swap
                swapImage(imgUrl);
            }, 0);
        }

        function swapImage(url){
            // quit animation that might be happening currently
            $('.McAdvantagesCarouselImage').removeClass('isChanging');

            // hide image, after animation switch the picture, let some delay for the picture to load, show image
            $('.McAdvantagesCarouselImage').addClass('isChanging').delay(500).queue(function(){
                $(this).prop('src', url).delay(100).queue(function(){
                    $(this).removeClass('isChanging').dequeue();
                }).dequeue();
            });
        }
    }

});